export default __webpack_public_path__ + "static/media/digital-ocean.9e83adf9.svg";